/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React, { useMemo } from 'react';
import type { CashWorkspaceSection } from './cashManagement.types';
import { CashUnderlineTabBar } from './CashUnderlineTabBar';

type Props = {
  activeSection: CashWorkspaceSection;
  onChangeSection: (section: CashWorkspaceSection) => void;
  showCierres: boolean;
  showActividad: boolean;
  showEgresos: boolean;
  showCartera: boolean;
  /** Hay cierres con diferencia (7 d) — solo punto en tab, sin texto. */
  cierresNeedsAttention?: boolean;
};

/** Sub-tabs del workspace web (Turno | Historial | …). */
export function CashWorkspaceSectionToggle({
  activeSection,
  onChangeSection,
  showCierres,
  showActividad,
  showEgresos,
  showCartera,
  cierresNeedsAttention,
}: Props) {
  const options = useMemo(() => {
    const items: Array<{ value: CashWorkspaceSection; label: string; attention?: boolean }> = [
      { value: 'operacion', label: 'Turno' },
    ];
    if (showCartera) items.push({ value: 'cartera', label: 'Cartera' });
    if (showCierres) {
      items.push({
        value: 'cierres',
        label: 'Historial',
        attention: cierresNeedsAttention,
      });
    }
    if (showActividad) items.push({ value: 'actividad', label: 'Actividad' });
    if (showEgresos) items.push({ value: 'egresos', label: 'Egresos' });
    return items;
  }, [cierresNeedsAttention, showActividad, showCartera, showCierres, showEgresos]);

  return <CashUnderlineTabBar options={options} value={activeSection} onChange={onChangeSection} />;
}
